<template>
  <el-checkbox v-if="isEidt" v-model="params.data[field]" :true-label="trueLabel" :false-label="falseLable" @change="onChange" />
  <span v-else>{{ disabledFormatter(params.data[field]) }}</span>
</template>

<script>
export default {
  name: 'CargoGridOptCheckBox',
  data() {
    return {
      field: '',
      isEidt: true,
      trueLabel: true,
      falseLable: false,
      disabledFormatter: val => val,
      valueChanged: undefined
    }
  },
  created() {
    const colDef = this.params.colDef
    this.field = colDef.field
    if (colDef.custom) {
      const custom = colDef.custom
      if (typeof custom.editable === 'function') {
        this.isEidt = !!custom.editable(this.params)
      } else {
        this.isEidt = !!custom.editable
      }
      if (custom.hasOwnProperty('trueLabel')) {
        this.trueLabel = custom.trueLabel
      }
      if (custom.hasOwnProperty('falseLable')) {
        this.falseLable = custom.falseLable
      }
      if (custom.hasOwnProperty('disabledFormatter')) {
        this.disabledFormatter = custom.disabledFormatter
      }
      if (custom.hasOwnProperty('valueChanged')) {
        this.valueChanged = custom.valueChanged
      }
    }
  },
  methods: {
    onChange() {
      this.params.setValue(this.params.data[this.field])
      if (typeof this.valueChanged === 'function') {
        this.valueChanged({
          node: this.params.node,
          data: this.params.data,
          value: this.params.data[this.field]
        })
      }
    }
  }
}
</script>
